export default __webpack_public_path__ + "static/media/kitchen3-afterG-2048w.e11e84e5.webp";